import { useEffect, useRef } from 'react';

export const useInitAd = (adId: string) => {
  const hasInitializedRef = useRef(false);

  useEffect(() => {
    if (hasInitializedRef.current) return;

    // 外部スクリプトを動的に作成して追加
    const script = document.createElement('script');
    script.id = 'initialize-microad';
    script.type = 'text/javascript';
    script.charset = 'utf8';
    script.src = '//j.microad.net/js/compass.js';
    script.async = true;

    script.addEventListener('load', () => {
      try {
        // @ts-ignore
        new microadCompass.AdInitializer().initialize();
      } catch (error) {
        console.log(error);
      }

      // 無名関数を実行
      const anonymousFunction = `(function() {
                microadCompass.queue.push({"spot": "${adId}"});
              })();`;

      const executeScript = document.createElement('script');
      executeScript.textContent = anonymousFunction;
      document.body.append(executeScript);

      // クリーンアップ関数
      return () => {
        executeScript.remove();
      };
    });

    document.body.append(script);

    hasInitializedRef.current = true;
  }, [adId]);
};
